import { Link } from "react-router-dom";
import { useEffect, useRef } from "react";

const NotFoundPage = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    const particles = Array.from({ length: 40 }, () => ({
      x: Math.random() * canvas.width, y: Math.random() * canvas.height,
      r: Math.random() * 1.5 + 0.3, vx: (Math.random() - 0.5) * 0.3, vy: (Math.random() - 0.5) * 0.3,
      alpha: Math.random() * 0.4 + 0.1,
      color: Math.random() > 0.5 ? '212,175,55' : '220,38,38',
    }));

    let frame;
    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${p.color},${p.alpha})`; ctx.fill();
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0 || p.x > canvas.width) p.vx *= -1;
        if (p.y < 0 || p.y > canvas.height) p.vy *= -1;
      });
      frame = requestAnimationFrame(draw);
    };
    draw();
    return () => cancelAnimationFrame(frame);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden" style={{ background: '#050508' }}>
      <canvas ref={canvasRef} className="absolute inset-0 w-full h-full pointer-events-none opacity-50" />

      <div className="relative z-10 text-center px-6 max-w-lg">
        {/* Giant 404 */}
        <div className="relative mb-6">
          <div
            className="text-[10rem] font-black leading-none select-none"
            style={{
              fontFamily: 'Cinzel, serif',
              background: 'linear-gradient(135deg, rgba(255,255,255,0.05), rgba(212,175,55,0.15))',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              filter: 'drop-shadow(0 0 40px rgba(212,175,55,0.3))',
            }}
          >
            404
          </div>
          {/* Floating card illustration */}
          <div
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-8xl"
            style={{ animation: 'float 3s ease-in-out infinite', filter: 'drop-shadow(0 10px 30px rgba(0,0,0,0.5))' }}
          >
            🃏
          </div>
        </div>

        <div className="px-4 py-1.5 rounded-full text-xs font-black uppercase tracking-widest mb-4 inline-block"
          style={{ background: 'rgba(220,38,38,0.15)', border: '1px solid rgba(220,38,38,0.4)', color: '#dc2626' }}>
          Duelo Interrumpido
        </div>

        <h1 className="text-3xl font-black mb-3" style={{ fontFamily: 'Cinzel, serif', color: '#fff' }}>
          Página no encontrada
        </h1>
        <p className="text-gray-400 mb-8 text-sm leading-relaxed">
          Esta carta no está en nuestra base de datos.<br />
          Regresa al campo de batalla y sigue dueling.
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <Link to="/" className="px-8 py-3 rounded-full font-black text-sm uppercase tracking-wide transition-all hover:scale-105"
            style={{ background: 'linear-gradient(135deg,#dc2626,#b91c1c)', color: '#fff', boxShadow: '0 6px 20px rgba(220,38,38,0.35)' }}>
            Volver al Inicio
          </Link>
          <Link to="/ranking" className="px-8 py-3 rounded-full font-bold text-sm uppercase tracking-wide transition-all hover:scale-105"
            style={{ border: '1px solid rgba(212,175,55,0.4)', color: '#d4af37', background: 'rgba(212,175,55,0.08)' }}>
            Ver Rankings
          </Link>
        </div>
      </div>

      <style>{`
        @keyframes float { 0%,100%{transform:translate(-50%,-50%) translateY(0)} 50%{transform:translate(-50%,-50%) translateY(-15px)} }
      `}</style>
    </div>
  );
};

export default NotFoundPage;
